import { useEffect } from 'react';

const useCollapsedSkybox = (isCollapsedByDefault: boolean) => {
  useEffect(() => {
    document.body.classList.toggle(
      'skybox-auto-collapse',
      isCollapsedByDefault
    );
  }, [isCollapsedByDefault]);
};

export default useCollapsedSkybox;
